import { doc, getDoc, getDocs, query,  updateDoc, where } from 'firebase/firestore/lite';
import React, { useEffect, useState } from 'react'
import { db, userData, userId } from '../../firebase.config';
import { useNavigate } from 'react-router-dom';

function ChangeAddress() {
  const [formValues, setFormValues] = useState({
    name: "",
    mobile: null,
    pin: null,
    house: "",
    street: "",
    landmark: "",
    city: "",
    state: "",
  });

  const [preValue, setPreValue] = useState({});
  console.log(preValue);

  const [docId,setDocId] = useState()
    console.log(docId);
  //FETCH Address..
  useEffect(() => {
    async function fetchAddress() {
      const userDoc = await getDocs(
        query(userData, where("uid", "==", userId))
      );
      setDocId(userDoc.docs[0].id)

      const docRef = doc(db, "users", docId);
      const data = await getDoc(docRef, );

      const result = { ...data.data().address};
      setPreValue(result);
      console.log("dara",data.data().address);

      return 0;
    }
    fetchAddress();
}, [docId]);

//SET FORM VALUE
useEffect(()=>{
    function getPreValue(){
        setFormValues(({
          name: preValue.name,
          mobile: preValue.mobile,
          pin: preValue.pin,
          house: preValue.house,
          street: preValue.street,
          landmark: preValue.landmark,
          city: preValue.city,
          state: preValue.state?preValue.state:"",
        }));
    }
    getPreValue()
  },[preValue])

  const [herState,setHerstate] = useState(true)
  const navigate = useNavigate()
  //WHEN SUBMITTING..
  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setHerstate(formValues.state.length!==0? true : false); 
    if(herState){
    try {
        console.log(docId);
      await updateDoc(doc(db, "users", docId), {address: formValues}); // Update the AddressData document with the form data
      console.log("Document updated successfully!");
      alert("Address updated successfully!")
    } catch (error) {
      console.error("Error updating document: ", error);
    }
    navigate('/address')
  }else{
    alert("no state")
  }
  };

  return (
    <div className="px-14 py-4 pb-20">
      <div className="bg-slate-800 p-6 px-12 rounded-xl">
        <p className="text-center py-3 text-blue-500 text-lg font-bold tracking-widest">
          DELIVERY ADDRESS
        </p>
        <form className="text-center" onSubmit={handleFormSubmit}>
          <div className="mb-6">
            <label
              for="mobile"
              className="block mb-2 text-sm font-medium  text-slate-400 text-center"
            >
              Full Name
            </label>
            <input
              type="text"
              id="name"
              className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Full Name"
              required
              value={formValues.name}
              onChange={(event) =>
                setFormValues({ ...formValues, name: event.target.value })
              }
            />
          </div>
          <div className="mb-6">
            <label
              for="mobile"
              className="block mb-2 text-sm font-medium text-slate-400 text-center"
            >
              Moile
            </label>
            <input
              type="number"
              id="mobile"
              className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required
              value={formValues.mobile}
              onChange={(event) =>
                setFormValues({ ...formValues, mobile: event.target.value })
              }
            />
          </div>
          <div className="mb-6">
            <label
              for="pin"
              className="block mb-2 text-sm font-medium text-slate-400 text-center"
            >
              Pin
            </label>
            <input
              type="number"
              id="pin"
              className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required
              placeholder="Pin code"
              value={formValues.pin}
              onChange={(event) =>
                setFormValues({ ...formValues, pin: event.target.value })
              }
            />
          </div>
          <div className="mb-6">
            <label
              for="house"
              className="block mb-2 text-sm font-medium text-slate-400 text-center"
            >
              House
            </label>
            <input
              type="text"
              id="house"
              className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required
              placeholder="House no, Flat, Building, Company, Apartment"
              value={formValues.house}
              onChange={(event) =>
                setFormValues({ ...formValues, house: event.target.value })
              }
            />
          </div>
          <div className="mb-6">
            <label
              for="street"
              className="block mb-2 text-sm font-medium text-slate-400 text-center"
            >
              street
            </label>
            <input
              type="text"
              id="street"
              className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required
              placeholder="Area, Street, Setor, Village"
              value={formValues.street}
              onChange={(event) =>
                setFormValues({ ...formValues, street: event.target.value })
              }
            />
          </div>
          <div className="mb-6">
            <label
              for="landmark"
              className="block mb-2 text-sm font-medium text-slate-400 text-center"
            >
              Landmark
            </label>
            <input
              type="tex"
              id="landmark"
              className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required
              value={formValues.landmark}
              onChange={(event) =>
                setFormValues({
                  ...formValues,
                  landmark: event.target.value,
                })
              }
            />
          </div>
          <div className="mb-6">
            <label
              for="city"
              className="block mb-2 text-sm font-medium text-slate-400 text-center"
            >
              Town/City
            </label>
            <input
              type="tex"
              id="city"
              className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required
              value={formValues.city}
              onChange={(event) =>
                setFormValues({
                  ...formValues,
                  city: event.target.value,
                })
              }
            />
          </div>
          <div className="mb-6">
            <label
              for="state"
              className="block mb-2 text-sm font-medium text-slate-400 text-center"
            >
              State
            </label>
            <select
              type="tex"
              id="state"
              className="text-center bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required
              value={formValues.state}
              onChange={(event) =>
                setFormValues({
                  ...formValues,
                  state: event.target.value,
                })
              }
            >
              {formValues.state?.length !== 0 ? (
                <option value={formValues.state}>{formValues.state}</option>
              ) : (
                ""
              )}
              <option value="" disabled>select your State</option>
              <option value="Kerala">Kerala</option>
              <option value="Tamilnadu">Tamil Nadu</option>
            </select>
            { herState ? "" : <p className='text-red-400 mt-2'>Plese select your state</p>}
          </div>

          <button
            type="submit"
            className=" text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            Update
          </button>
        </form>
      </div>
    </div>
  );
}

export default ChangeAddress